module.exports = __webpack_public_path__ + "img/accordion-icon-white.6dc4d712.svg";